import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=7bcdd9d2&"
import script from "./TagInput.vue?vue&type=script&lang=ts&"
export * from "./TagInput.vue?vue&type=script&lang=ts&"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=7bcdd9d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports